import axios from 'axios';
import { axiosInstance } from '../common/api';
import { API_BASE_URL } from '../utils/envVariables';

// Public — plain axios with no auth interceptor.
// Founders may not have a Clockies account, so no Authorization header is added.
export const getReportByToken = (token) =>
  axios.get(`${API_BASE_URL}/api/report-track/view/${token}`);

// Authenticated — standard axiosInstance used by all other services.
export const getReportTrackingStats = (filters = {}, pagination = {}) => {
  const params = new URLSearchParams();
  if (filters.weekStartDate) params.append('weekStartDate', filters.weekStartDate);
  if (filters.projectId) params.append('projectId', filters.projectId);
  params.append('page', pagination.page || 1);
  params.append('pageSize', pagination.pageSize || 20);
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(`/report-track/stats?${params.toString()}`)
      .then(resolve)
      .catch(reject),
  );
};
